import { render, staticRenderFns } from "./NileStepperRegistrationForm.vue?vue&type=template&id=160882d0&"
import script from "./NileStepperRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./NileStepperRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports